<template>
  <div class="agency-contact-embedded section">
    <div class="section__wrapper">
      <!-- Note: don't remove id - it is used as a hash anchorpoint -->
      <div id="contact" class="agency-contact-embedded__form">
        <agency-contact :embedded-form="true" :form-version="formVersion"></agency-contact>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
import type { AgencyContactEmbeddedSectionType } from '@/schemas/landingPageSchema';

const props = defineProps<{
  content: AgencyContactEmbeddedSectionType['content'];
}>();

const { formVersion } = props.content;

const AgencyContact = defineAsyncComponent(() => import('@/app/components/agency-contact/agency-contact.vue'));
</script>
